import { Injectable } from '@angular/core';
import { User } from 'src/app/user';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';
import * as JsEncryptModule from 'jsencrypt';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }

  urlConstants = environment.url;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };

  rsaenc(key,value){
    var jencrypt = new JsEncryptModule.JSEncrypt({});
    var text = value.trim();
    jencrypt.setPublicKey(key);
    var cp = jencrypt.encrypt(text);
    return cp;
  }
  rsadec(key,value ){
    var decrypt = new JsEncryptModule.JSEncrypt({});
    decrypt.setPrivateKey(key);
    var cp = decrypt.decrypt(value);
    return cp;
  }

  getuserlogin(options: object): Observable<any>{
    let loginuser = "login-with-encryption";
    return this.http.post<any>(ProjConstants.API_AUTH_URL + loginuser, options)
  }

  public login(userInfo: User):Observable<any>  {
    var userName = this.rsaenc(ProjConstants.RSA_PUBLIC_KEY,userInfo.username+","+userInfo.password);
    var lock = false;
    var userInfoEncrypt = false;
    var postParm = {
      "username" : userName,
      "lock" : lock,
      "userInfoEncrypted" : userInfoEncrypt
    }
    
    return this.getuserlogin(postParm);
  }

  public isLoggedIn() {
    if(localStorage.getItem('ACCESS_TOKEN') && localStorage.getItem('ACCESS_TOKEN') !== "") {
      return true;
    }
    return false ;
  }

  public logout() {
    return this.http.post<any>(this.urlConstants.PLAY_URL+'logout',{}).pipe(
      map(response => {
        localStorage.removeItem('ACCESS_TOKEN');
        return response;
      })
    );
  }

  public generateOtp(userInfo: any) {
    console.log(userInfo);
    return this.http.post<any>(this.urlConstants.PLAY_URL+'forgot-password',userInfo,this.httpOptions)
    .pipe(
      map(response => {
        localStorage.setItem('USERID',userInfo.userId);
        return response;
      })
    );
    
  }

  public validateOtp(otpInfo: any) {
    let resetInfo = {userId : localStorage.getItem('USERID'), otp: otpInfo}
    return this.http.post<any>(this.urlConstants.PLAY_URL+'validate-otp',resetInfo,this.httpOptions);
  }

  public resetPassword(newPassword: any) {
    let resetInfo = {userId : localStorage.getItem('USERID'), password: Base64.stringify(sha256(newPassword))}
    return this.http.post<any>(this.urlConstants.PLAY_URL+'reset-password',resetInfo,this.httpOptions);
  }


}
